import React, { useCallback, useEffect, useState } from 'react';
import {
	Box,
	Button,
	Checkbox,
	Chip,
	ClickAwayListener,
	FormControlLabel,
	Grow,
	InputAdornment,
	Link,
	List,
	ListItem,
	Paper,
	Popper,
	Switch,
	TextField,
	Tooltip,
	Typography,
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { getLocalStorageItem } from '../../../services/StorageService';
import ReactDateRangePicker from '../../Common/ReactDateRangePicker';
import { Enums } from '../../../config/enums';
import { OKRButton } from '../../Common/OKRButton';
import { CrossIcon, NewFilterIcon, ResetIcon } from '../../../config/svg/CommonSvgIcon';
import { SearchIcon } from '../../../config/svg/CommonSvg';
import { DownArrowIcon, UpArrowIcon } from '../../../config/svg/ArrowSvg';
import { CancelIcon } from '../../../config/svg/Action';
import { BorderCheckboxIcon, CheckedIcon } from '../../../config/svg/formElementIcons';
import _ from 'lodash';

export const CommonFilters: React.FC<any> = (props: any) => {
	const {
		minDateValue,
		maxDateValue,
		selectedFilterDateRange,
		setSelectedFilterDateRange = () => {},
		searchTextArray,
		setSearchTextArray = () => {},
		handleSearchText,
		finalFilterCondition,
		setFinalFilterCondition,
		defaultFinalSettings,
		searchValue,
		setSearchValue,
		defaultLocalSettings,
		defaultLocalEmptySettings,
		defaultEmptyFinalSettings,
		pipFiltersList,
		type = 'pip',
	} = props;
	const { t } = useTranslation();
	const dispatch = useDispatch();
	const currentCycleDetails = getLocalStorageItem('currentCycle');
	const curCycleData = currentCycleDetails ? JSON.parse(currentCycleDetails) : {};
	const startDateValue = new Date();
	startDateValue.setMonth(startDateValue.getMonth() - 6);

	useEffect(() => {
		if (defaultFinalSettings && defaultFinalSettings.status && defaultFinalSettings.status.length > 0) {
			setAppliedFilter(true);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [defaultFinalSettings]);
	const [isDateRangeChanged, setIsDateRangeChanged] = useState<any>(null);

	const dateChanged = (range: any) => {
		range && setIsDateRangeChanged(true);
		range && setSelectedFilterDateRange(range);
	};
	const resetCalendarDate = () => {
		setIsDateRangeChanged(false);
		setSelectedFilterDateRange(null);
	};

	const searchClicked = (e: any) => {
		if (e.key === 'Enter') {
			if (e.target.value && e.target.value.trim() !== '') {
				setSearchTextArray(e.target.value);
				handleSearchText(e.target.value);
			}
			setSearchValue('');
		}
	};

	const delayedQuery = useCallback(
		_.debounce((q) => _handleSearch(q), 500),
		[]
	);
	const handleInputThrottled = (value: any) => {
		setSearchValue(value);
		delayedQuery(value);
	};
	const _handleSearch = (e: any) => {
		handleSearchText(e);
	};

	const clearSearch = () => {
		setSearchTextArray('');
		handleSearchText('');
	};

	const [openFilter, setOpenFilter] = useState<boolean>(false);
	const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
	const [appliedFilter, setAppliedFilter] = useState<boolean>(false);
	const [localFilterCondition, setLocalFilterCondition] = useState<any>(defaultLocalSettings);
	const handleToggleFilter = (event: any) => {
		setAnchorEl(event.currentTarget);
		setOpenFilter((prev) => !prev);
	};

	const handleClose = (event: any) => {
		setAnchorEl(null);
		setOpenFilter(false);
	};
	const handleCloseChip = (value: any) => {
		let filterData: any = { ...localFilterCondition };
		let indexParent = filterData[value.type].indexOf(value.performanceImprovementPlanStatusId);
		if (indexParent !== -1) {
			filterData[value.type].splice(indexParent, 1);
		}
		setLocalFilterCondition(filterData);
		handleApplyFilterClick(filterData);
	};
	const handleFilterChanged = (key: any, value: number) => {
		let filterData: any = { ...localFilterCondition };
		if (filterData[key]) {
			let indexParent = filterData[key].indexOf(value);
			if (indexParent === -1) {
				filterData[key].push(value);
			} else {
				filterData[key].splice(indexParent, 1);
			}
		} else {
			filterData[key] = [];
			filterData[key].push(value);
		}
		setLocalFilterCondition(filterData);
	};
	const clearFilter = () => {
		setLocalFilterCondition(defaultLocalEmptySettings);
		setFinalFilterCondition(defaultEmptyFinalSettings);
	};

	const handleApplyFilterClick = (filtersData: any) => {
		let filters: any = {
			...defaultLocalEmptySettings,
			filterData: [],
		};
		pipFiltersList.forEach((item: any) => {
			item.values.map((value: any, index: number) => {
				if (
					filtersData[item.performanceImprovementPlanStatusId] &&
					filtersData[item.performanceImprovementPlanStatusId].indexOf(value.performanceImprovementPlanStatusId) !== -1
				) {
					if (filters[item.performanceImprovementPlanStatusId]) {
						filters[item.performanceImprovementPlanStatusId].push({
							...value,
							type: item.performanceImprovementPlanStatusId,
						});
					} else {
						filters[item.performanceImprovementPlanStatusId] = [];
						filters[item.performanceImprovementPlanStatusId].push({
							...value,
							type: item.performanceImprovementPlanStatusId,
						});
					}
					filters.filterData.push({ ...value, type: item.performanceImprovementPlanStatusId });
				} else if (!filtersData[item.performanceImprovementPlanStatusId]) {
					//filtersData[item.performanceImprovementPlanStatusId] = '';
				}
			});
		});
		setAppliedFilter(true);
		setFinalFilterCondition({
			...filters,
		});
	};
	return (
		<Box className='pip-header-right-actions'>
			<Box className='range-selector-calender'>
				<ReactDateRangePicker
					type={'PipDateRange'}
					tooltipText={type !== 'feedback' ? t('PipListDateRangeText') : t('FeedbackListDateRangeText')}
					hideTooltip={type !== 'feedback'}
					selectedCycleDetails={curCycleData || {}}
					startDateValue={null}
					endDateValue={null}
					minimumDate={minDateValue ? new Date(minDateValue) : new Date()}
					maximumDate={maxDateValue ? new Date(maxDateValue) : new Date()}
					handleDateSelection={(range: any, start: any, end: any, selectionType: any, isCycleChanged: any) => {
						dateChanged(range);
					}}
					isDateRangeTextFieldVisible={true}
					isOnlyDueDateVisible={false}
					allCycleDetails={[]}
					isCycleVisible={false}
					isEndOfMonthVisible={false}
					numberOfCalendars={Enums.TWO}
					selectionType={'range'}
					selectedDateRange={selectedFilterDateRange}
					setSelectedDateRange={() => {}}
					placeholderText={t('dateRangeText')}
				/>
				{selectedFilterDateRange ? (
					<OKRButton
						className='btn-circle-blue reset-btn'
						icon={<ResetIcon />}
						title={t('resetDates')}
						handleClick={(e: any) => resetCalendarDate()}
					/>
				) : (
					<></>
				)}
			</Box>
			<Box className='goal-okr-filter alignment-map-filter'>
				<OKRButton
					className={`list-filter-btn ${openFilter ? 'active' : ''}`}
					icon={<NewFilterIcon />}
					text={
						<span className='filter-txt'>
							{t('filterLabel')}
							{openFilter ? <UpArrowIcon /> : <DownArrowIcon />}
						</span>
					}
					handleClick={handleToggleFilter}
					id='dashboard-filter-btn'
				/>
				<Box className={`filter-chip `}>
					{appliedFilter && (
						<List>
							{finalFilterCondition?.filterData?.length ? (
								<>
									{finalFilterCondition.filterData.slice(0, 1).map((item: any, index: any) => (
										<ListItem key={index}>
											<Tooltip arrow title={item.name}>
												<Typography variant='body2'>{item.name}</Typography>
											</Tooltip>
											<Button className='cancel-btn' onClick={() => handleCloseChip(item)}>
												<CancelIcon />
											</Button>
										</ListItem>
									))}
									{finalFilterCondition.filterData.length > 1 && (
										<ListItem className='more-filter-count'>
											<Typography variant='body2'>+{finalFilterCondition.filterData.length - 1}</Typography>
										</ListItem>
									)}

									<ListItem className='clear-all'>
										<Link onClick={clearFilter}>{t('clearAll')}</Link>
									</ListItem>
								</>
							) : (
								<></>
							)}
						</List>
					)}
				</Box>
				<Popper
					className={`okr-filter alignmentmap-filter-list task-filter-popup`}
					open={openFilter}
					anchorEl={anchorEl}
					id='filtersPopper'
					placement={'bottom-start'}
					modifiers={{
						flip: {
							enabled: false,
						},
					}}
				>
					{({ TransitionProps }) => (
						<Grow {...TransitionProps}>
							<ClickAwayListener onClickAway={handleClose}>
								<Paper>
									<Box className='task-filter-wrap'>
										<Box className='task-filter-wrap-inner'>
											{pipFiltersList?.map((item: any) => (
												<>
													{item.values && item.values.length > 0 && (
														<Box className='task-priority-filter'>
															<Typography variant='body2'>{item.label}</Typography>
															<List>
																{item.values.map((value: any, index: number) => {
																	return (
																		<ListItem key={`type-filter-date-list-${value.performanceImprovementPlanStatusId}`}>
																			<FormControlLabel
																				control={
																					<Checkbox
																						icon={<BorderCheckboxIcon />}
																						checkedIcon={<CheckedIcon />}
																						checked={
																							localFilterCondition &&
																							localFilterCondition[item.performanceImprovementPlanStatusId] &&
																							localFilterCondition[item.performanceImprovementPlanStatusId].includes(
																								value.performanceImprovementPlanStatusId
																							)
																						}
																						value={value.performanceImprovementPlanStatusId}
																						onChange={(e) =>
																							handleFilterChanged(
																								item.performanceImprovementPlanStatusId,
																								value.performanceImprovementPlanStatusId
																							)
																						}
																						color='primary'
																					/>
																				}
																				label={value.name}
																			/>
																		</ListItem>
																	);
																})}
															</List>
														</Box>
													)}
												</>
											))}
										</Box>
										<Box className='task-filter-actions'>
											<OKRButton
												className='apply-btn btn-primary'
												text={t('applyLabel')}
												handleClick={(e: any) => {
													handleClose(e);
													handleApplyFilterClick(localFilterCondition);
												}}
											/>
										</Box>
									</Box>
								</Paper>
							</ClickAwayListener>
						</Grow>
					)}
				</Popper>
			</Box>
			<Box className='user-search'>
				{type === 'feedback' ? (
					<TextField
						className='search-text-field'
						id='user-src-field'
						placeholder={'Search by user'}
						fullWidth
						value={searchValue}
						onChange={(e: any) => handleInputThrottled(e.target.value)}
						onKeyDown={(e: any) => searchClicked(e)}
						InputProps={{
							startAdornment: (
								<InputAdornment position='start'>
									<SearchIcon />
								</InputAdornment>
							),
						}}
					/>
				) : (
					<Tooltip title={t('searchUserForPip')} arrow>
						<TextField
							className='search-text-field'
							id='user-src-field'
							placeholder={t('searchByNominee')}
							fullWidth
							value={searchValue}
							onChange={(e: any) => handleInputThrottled(e.target.value)}
							onKeyDown={(e: any) => searchClicked(e)}
							InputProps={{
								startAdornment: (
									<InputAdornment position='start'>
										<SearchIcon />
									</InputAdornment>
								),
							}}
						/>
					</Tooltip>
				)}
				{searchTextArray && (
					<Box className='user-search-chip'>
						<List>
							<ListItem>
								{searchTextArray.length > 20 ? (
									<Tooltip title={searchTextArray} arrow>
										<Chip
											label={searchTextArray.substring(0, 20) + '...'}
											onDelete={clearSearch}
											deleteIcon={
												<span>
													<CrossIcon />
												</span>
											}
										/>
									</Tooltip>
								) : (
									<Chip
										label={searchTextArray}
										onDelete={clearSearch}
										deleteIcon={
											<span>
												<CrossIcon />
											</span>
										}
									/>
								)}
							</ListItem>
						</List>
					</Box>
				)}
			</Box>
		</Box>
	);
};
